import PropTypes from 'prop-types';
import PlusCourseCard from '@comp/PlusCourseCard/PlusCourseCard';
import { useSelector } from 'react-redux';
import { getFullCourseInfo } from '@selectors/courses';

const PlusCard = ({
  topic,
  courseData,
  toggleEnroll,
  className,
  index,
  orientation,
  gridColumn,
  imageBorderRadius,
  showProgress,
  lastPrimarySource,
  lastPrimarySourceSection
}) => {
  const course = useSelector((state) =>
    getFullCourseInfo(state, courseData.course)
  );
  return (
    <PlusCourseCard
      className={className}
      course={course}
      index={index}
      toggleEnroll={toggleEnroll(course)}
      type="syllabus"
      orientation={orientation}
      gridColumn={gridColumn}
      topic={topic}
      imageBorderRadius={imageBorderRadius}
      showProgress={showProgress}
      dataAnalytics="syllabus"
      lastPrimarySource={lastPrimarySource}
      label={lastPrimarySourceSection}
    />
  );
};

PlusCard.propTypes = {
  topic: PropTypes.objectOf(PropTypes.any).isRequired,
  courseData: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleEnroll: PropTypes.func.isRequired,
  className: PropTypes.string,
  index: PropTypes.number,
  gridColumn: PropTypes.string,
  orientation: PropTypes.string,
  imageBorderRadius: PropTypes.string,
  showProgress: PropTypes.bool,
  lastPrimarySource: PropTypes.string,
  lastPrimarySourceSection: PropTypes.string
};

PlusCard.defaultProps = {
  className: '',
  index: -1,
  gridColumn: 'span 18',
  orientation: 'horizontal',
  imageBorderRadius: '0px',
  showProgress: false,
  lastPrimarySource: '',
  lastPrimarySourceSection: ''
};

export default PlusCard;
